import React from 'react'
import PropTypes from 'prop-types'

import { Select, Label, Box } from 'pcln-design-system'

import { timeOptions } from './helpers'

export default function SelectTime({ min, max, name, label, onChange, value, isEndTime }) {
  const options = timeOptions(min, max, isEndTime).map((item) => {
    return (
      <option value={item.value} key={item.value}>
        {item.name}
      </option>
    )
  })

  function _onChange(event) {
    onChange(parseInt(event.target.value, 10))
  }

  return (
    <Box w={1} width={1}>
      <Label htmlFor={name}>{label}</Label>
      <Select pl={2} py={2} fontSize={0} id={name} name={name} onChange={_onChange} value={value}>
        {options}
      </Select>
    </Box>
  )
}

SelectTime.propTypes = {
  min: PropTypes.number,
  max: PropTypes.number,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.number,
  isEndTime: PropTypes.bool,
}
